module.exports = __webpack_public_path__ + "img/people-48-min.b810c80d.png";